import { Language } from '../features/Questionnaires/questionnaires';

export enum Languages {
  EN = 'en',
}

export interface LanguageState {
  locale: Languages;
  listLanguages: Language[];
}

export type LocaleMessages = Record<Languages, Record<string, string>>;
